import { ApiUrl } from "../util/constants/const";

export const ApiService = {
    changePassword: async (oobCode: string, password: string)
        : Promise<void> => {
        const response = await fetch(`${ApiUrl}/auth/change-password`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ oobCode, password, }),
        });

        const data = await response.json();

        if (data.statusCode !== 200) {
            throw new Error(data.message || 'Error al cambiar la contraseña');
        }
    }
};